module Widgets.Form.PhoneInput where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Data.Argonaut as J
import GraphQL.Shape (QueryField(..))
import Widgets.Form.Class (class FormWidget, fieldAccessProps, formWidgetState, fieldClass, fieldId, setFromJson)
import Widgets.Form.Common (widgetLabelS)


newtype PhoneInput = PhoneInput PhoneInputType
derive newtype instance showPhoneInput :: Show PhoneInput
type PhoneInputType =
    { id :: String
    , label :: String
    , cls :: String
    , placeholder :: Maybe String
    , value :: String
    }

instance phoneInputFW :: FormWidget PhoneInput where
    getId (PhoneInput state) = state.id
    isLeaf _ = true
    asField (PhoneInput state) = Just $ QScalar state.id
    fieldPaths fc (PhoneInput state) = [ fieldId fc state.id ]

    toWidget fc (PhoneInput state) = formWidgetState <$> D.div
        [ P.key id, P.className $ fieldClass state ]
        [ widgetLabelS fc state [ P.className "block w-full" ]
        , D.input
            ( [ P._type "tel", P._id id, P.name id, P.value state.value
            , P.className "widget-input"
            , P.placeholder $ fromMaybe "" state.placeholder
            , P.pattern "[0-9]{3}-[0-9]{3}-[0-9]{4}"
            , PhoneInput <$> state { value = _ } <$> P.unsafeTargetValue <$> P.onInput
            ] <> fieldAccessProps fc state.id )
        ]
      where id = fieldId fc state.id

    getData _ (PhoneInput state) = J.fromString state.value
    setData _ st@(PhoneInput state) =
        setFromJson st $ \val -> Right $ PhoneInput $ state { value = val }
